import styled from "@emotion/styled";
import { AppLogoWhite } from "../../assets/svgs";
import { validatePassword } from "../../utils/FieldsVerifications";
import InputEmail from "../CommonComponents/InputControls/InputEmail";
import InputPassword from "../CommonComponents/InputControls/InputPassword";
import styles from "./Login.module.css";
import { Button, Form, Row } from "antd";
import ReCAPTCHA from "react-google-recaptcha";
import { useState } from "react";
import AuthServices from "../../services/AuthServices";
import useNotification from "../../hooks/useNotification";
import Session from "store2";
import { useNavigate } from "react-router-dom";

const CustomForm = styled(Form)`
  && .ant-input {
    background: #ffffff26 !important;
    border: 0 solid #969696 !important;
    border-radius: 25px !important;
    color: white !important;
    font-size: 16px !important;
    outline: none !important;
    padding: 6px 16px 10px 16px !important;
    height: 40px;
  }

  && .form-control {
    font-size: 16px !important;
  }

  && .ant-input-password {
    background: transparent !important;
    border: 0 solid #969696 !important;
    padding: 0px !important;
  }

  && .ant-input-suffix {
    display: none !important;
  }

  && .ant-form-item {
    margin-bottom: 16px;
  }
`;

const Login = () => {
  const navigate = useNavigate();
  const { showNotification } = useNotification();
  const [loading, setLoading] = useState(false);
  const [captchaValue, setCaptchaValue] = useState(null);

  const onFinish = async (values) => {
    try {
      if (process.env.NODE_ENV === "production")
        if (!captchaValue) {
          handleSignInError("Please complete the CAPTCHA.");
          return;
        }

      setLoading(true);

      const res = await AuthServices.Login(values);

      if (res) {
        if (res.statusCode === 1) {
          if (res.sessionToken === "e") {
            Session.clear();
            Session.session("session_token", res.sessionToken);
          }
          navigate("/otp-verification", {
            state: {
              type: res.sessionToken,
              email: values.email,
            },
          });
        } else {
          handleSignInError(`${res.statusDesc}`);
        }
      } else {
        handleSignInError(`Error: ${res.statusDesc}`);
      }
    } catch (error) {
      console.log(error);
      if (error.statusCode === 0) {
        console.log("Error while sign in", error);
        handleSignInError(error.description);
      } else {
        handleSignInError("Error: Invalid credentials or user does not exist.");
      }
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleRecaptchaChange = async (value) => {
    setCaptchaValue(value);
    try {
      console.log("Captcha value:", value);
      const verifyOtpResponse = await AuthServices.ValidateCaptcha({
        captcha: value,
      });
      if (verifyOtpResponse.statusCode === 1) {
        console.log("verifyOtpResponse", verifyOtpResponse);
      } else {
        handleSignInError(`${verifyOtpResponse.statusDesc}`);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleSignInError = (error) => {
    setLoading(false);
    showNotification(error, "error");
  };

  return (
    <div className={styles.login_wrap}>
      <div className={styles.logo_wrap}>
        <AppLogoWhite />
      </div>
      <div className={styles.header_line}>Welcome back to IndexScore!</div>
      <Row type="flex" justify="center">
        <CustomForm
          name="basic"
          className={styles.form_wrap}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <InputEmail
            placeholder="Enter your email address"
            rules={[
              {
                required: true,
                message: "Email Address is required !",
                whitespace: false,
              },
              {
                type: "email",
                whitespace: false,

                message: "Email must be a valid email address !",
              },
            ]}
          />

          <InputPassword
            placeholder="********"
            rules={[
              {
                required: true,
                message: "Password is required !",
              },
              {
                validator: validatePassword,
              },
            ]}
          />
          <div className={styles.captcha_wrap}>
            <ReCAPTCHA
              sitekey="6LcBkkUqAAAAABU2sAocpwPrQZQRpUAocIhwaGAt"
              onChange={handleRecaptchaChange}
            />
          </div>
          <Form.Item>
            <Button
              className={styles.submit_btn}
              type="primary"
              htmlType="submit"
              loading={loading}
            >
              Submit
            </Button>
          </Form.Item>
        </CustomForm>
      </Row>
    </div>
  );
};

export default Login;
